import { shouldAddTrailingSlash } from '@/utils/route-path';

/** Vue Router：无尾斜杠时重定向到带尾斜杠的 canonical 路径 */
export function trailingSlashGuard(to, from, next) {
	if (shouldAddTrailingSlash(to.path)) {
		next({
			path: `${to.path}/`,
			query: to.query,
			hash: to.hash,
			replace: true,
		});
		return;
	}
	next();
}
